import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useState } from 'react';
import { useGetPanelBookingsForChallengeEmailQuery, useCreateCampaignChallengeMutation, PanelBooking } from '../../generated/graphql';
import { ModalWindow } from '../../components/ModalWindow';
import {  Email } from '@mui/icons-material';
import { Close } from '@mui/icons-material';
import { Button, TextareaAutosize } from '@mui/material';
import FieldTable from '../../components/field-table';
import { FieldTableColumnProps } from '../../components/FieldTable/FieldTableTypes';
import { Alert } from '@mui/material';

const cols:FieldTableColumnProps<PanelBooking>[] = [
    {
        accessor: 'panel.site.name',
        header: 'Site',
        dataType:'default',
        readOnly:true
    },
    {
        accessor: 'challengeable_status',
        header: 'Status',
        dataType:'default',
        readOnly:true,
        options:{
            renderViewer:({field})=>{
                switch(field.value) {
                    case 'CHALLENGEABLE': 
                    return 'Will challenge';
                    case 'UNCHALLENGEABLE:NO_POLE':
                        return 'No challenge necessary';
                    case 'UNCHALLENGEABLE:SLOT':
                        return 'Slot bookings cannot raise a challenge';
                    case 'UNCHALLENGEABLE:UNDER_CHALLENGE':
                        return 'Pole is already challenged';
                }
            }
        }
    },
    {
        accessor:'poleBookings[0].campaign.job_reference',
        header:'Job Ref',
        dataType:'default',
    },
    {
        accessor:'poleBookings[0].campaign.ourContact.name',
        header:'Contact',
        dataType:'default',
    }
];



export const ChallengeEmailDialog = ({reference, done, isShown,selectedBookings}) => {
    const [manualContent,setManualContent] = useState('');
    const [bookings,setBookings]= useState<Array<string>>([]);
    const [createChallenge] = useCreateCampaignChallengeMutation();
    useEffect(()=>{
        const sbArray:string[] = [];
        if(!selectedBookings) return;
        Object.entries(selectedBookings).forEach(([value,key])=>{
            if(key) { sbArray.push(value); }
        });
        setBookings(sbArray);
    },[selectedBookings]);
    const bookingResults = useGetPanelBookingsForChallengeEmailQuery({
        variables: {
            ref: reference,
            bookings:bookings
        },
        skip: !isShown,
        fetchPolicy: "network-only"
    });
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const onCancel = useCallback(() => {
        done(false);
    }, [done]);

    const doCreateChallenge = useCallback(async ()=>{
        enqueueSnackbar('Creating challenge');
        try {
            await createChallenge({variables:{campaign_id:bookingResults?.data?.campaign?.id,message:manualContent,panelBookings:bookings}});
            enqueueSnackbar('Challenge created',{variant:'success'});
        } catch(e) {
            enqueueSnackbar(e && e.message?e.message:'Unable to create challenge',{variant:'error'});
        }
        done(true);
    },[manualContent,bookings,bookingResults?.data?.campaign?.id]);
    let willChallenge = 0;
    bookingResults?.data?.campaign?.panelBookings?.forEach(panelBooking=>{
        if(panelBooking?.challengeable_status=='CHALLENGEABLE') {
            willChallenge++;
        }
    });
    const msg = (willChallenge>0?
        'A challenge will be raised against '+willChallenge+' panel bookings.':
        'None of the selected panels are challengeable within this timeframe');

    return (<ModalWindow
        isOpen={isShown}
        onClose={()=>null}
        maxWidth='lg'
        className="campaign__econtract-dialog"
        header={<div style={{display:'flex',alignItems:'center'}}><Email/> &nbsp; Challenge Email </div>}
        actions={<>
            <Button variant="contained" onClick={onCancel} startIcon={<Close/>}>Close</Button>
            <Button disabled={willChallenge<=0} variant="contained" onClick={doCreateChallenge} startIcon={<Email/>}>Create Challenge</Button>
            </>
        }><>
        <FieldTable columns={cols} loading={!bookingResults.data || bookingResults.loading} values={bookingResults?.data?.campaign?.panelBookings} name="campaign.panelBookings"
        hasDelete={false} readOnly={true}/>
        <TextareaAutosize style={{width:"100%"}} value={manualContent} onChange={(evt)=>{setManualContent(evt.target.value)}} placeholder="Any text to put before the body"></TextareaAutosize>
        {!bookingResults.loading && <Alert severity="info">{msg}</Alert>}
    </>
    </ModalWindow>);

}